import { AspectRatio } from '@mantine/core';
import styles from './myImagePickerItem.module.css';

type MyImagePickerItemProps = {
  src: string;
  alt: string;
  compact?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  onClose?: () => void;
};

export const MyImagePickerItem = ({ src, alt, compact = false, style, onClick, onClose }: MyImagePickerItemProps) => {
  return (
    <>
      <div
        className={styles.picker}
        style={{
          ...style,
        }}
        onClick={() => {
          onClick?.();
          onClose?.();
        }}
        onKeyUp={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            onClick?.();
            onClose?.();
          }
        }}
      >
        <AspectRatio
          ratio={720 / 1080}
          maw={compact ? 150 : 300}
          mah={compact ? 150 : 300}
          mx="auto"
          style={{ borderRadius: 16 }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              ...style,
              borderRadius: 16,
              maxWidth: '300px',
              maxHeight: '300px',
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        </AspectRatio>
      </div>
    </>
  );
};
